<div style="padding: 16px 0;height: 43px;">
  <div class="caption1" style="display: flex; justify-content: space-around;margin-bottom: 12px; cursor: pointer;">
    <div routerLink="/data-privacy">{{ locale.currentTranslation.dataPrivacy }}</div>
    <div routerLink="/imprint">{{ locale.currentTranslation.imprint }}</div>
    <div routerLink="/data-privacy">Cookies</div>
  </div>
  <div class="disclaimer">{{ locale.currentTranslation.footerText }}</div>
</div>
